var navPageParamList = [
  'forceFlatResults',
  'facet',
  'emphasize',
  'orderBy',
  'pageNumber',
  'onlyFlags',
  'categoryId',
  'trackAsSearch',
  'exclude',
  'siteFormat',
  'splashRedirect',
];

//This config basically governs the path that node gets requested at and the api call it makes to commerce.
//It also determines what params get sent to commerce.
//It also determines what default cache tags get added to the response of the request in addition to other programatic ones.
//There is an optional timeout config option that will allow you to give certain paths a different timeout.  This can be handy for very expensive calls that could easily go over the default 30s timeout.
var pathConfig = {
  nodePathsInOrder: [
    '/stores/:name/:storeNum',
    '/stores/:stateName/:name/:storeNum',
    '/stores',
    '/stores/all',
    '/stores/:stateName',
    '/p/:name/:productId',
    '/p/:name/:productId/outfit',
    '/p/:name/:productId/sale',
    '/chanel/c/:pathToken',
    '/c/:pathToken',
    '/c/:pathToken/:pathModifier',
    '/c/:pathToken/:pathModifier/:color',
    '/c/:pathPrefix/:pathToken/:pathModifier/:color',
    '/brand/sale-clearance/:manufacturer',
    '/brand/sale-clearance/:manufacturer/:categoryName',
    '/brand/sale-clearance/:manufacturer/:categoryName/:pathModifier',
    '/brand/:manufacturer',
    '/brand/:manufacturer/:categoryName',
    '/brand/:manufacturer/:categoryName/:pathModifier',
    '/search-term/:searchTerm',
    '/search-term/:searchTerm/:categoryName',
    '/search-term/:searchTerm/:categoryName/:pathModifier',
    '/search-term/:pathToken/:searchTerm/:categoryName/:pathModifier',
    '/oss',
    '/collections',
    '/personalizedProducts',
    '/mobilemenu',
    '/',
    '/contactus',
    '/internationalhelp',
    '/events/:eventId',
    '/store-purchase-returns',
    '/member/subscriptions',
    '/changecountry',
    '/feedback/:templateId',
    '/my-preferences',
    '/member/my-appointments',
    '/member/manage-dillards-card',
    '/checkout/phone-orders/:orderID',
    '/error/:status',
  ],
  cookiePassNodePathsInOrder: [
    '/member/my-appointments',
    // '/cart'
    //'/member/wishlist'
    // '/member/subscriptions',
    // '/search-term/:searchTerm',
    // '/search-term/:searchTerm/:categoryName',
    // '/search-term/:searchTerm/:categoryName/:pathModifier',
  ],
  '/cart': {
    nodeDataPath: '/data/cart*',
    wcsDataPath: '/webapp/wcs/stores/servlet/OrderItemDisplay?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [],
  },
  '/stores/:stateName': {
    nodeDataPath: '/data/stores/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/StoreLocatorView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['stores'],
  },
  '/stores': {
    nodeDataPath: '/data/stores',
    wcsDataPath: '/webapp/wcs/stores/servlet/StoreLocatorView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['stores'],
  },
  '/stores/all': {
    nodeDataPath: '/data/stores',
    wcsDataPath: '/webapp/wcs/stores/servlet/StoreLocatorView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['stores'],
  },
  '/changecountry': {
    nodeDataPath: '/data/changecountry',
    wcsDataPath: false,
    acceptedQueryParameters: [],
    cacheTags: ['changecountry'],
  },
  '/contactus': {
    nodeDataPath: '/data/contactus',
    wcsDataPath: '/wcs/resources/store/301/survey/template/contactus',
    acceptedQueryParameters: [],
    cacheTags: ['contactus'],
  },

  '/internationalhelp': {
    nodeDataPath: '/data/internationalhelp',
    wcsDataPath: '/wcs/resources/store/301/survey/template/contactus',
    acceptedQueryParameters: [],
    cacheTags: ['internationalhelp'],
  },
  '/my-preferences': {
    nodeDataPath: '/data/my-preferences',
    wcsDataPath: '/webapp/wcs/stores/servlet/MobileMenu?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['my-preferences'],
  },
  '/member/my-appointments': {
    nodeDataPath: '/data/member/my-appointments',
    wcsDataPath: '/wcs/resources/store/301/event/track',
    acceptedQueryParameters: [],
  },
  '/feedback/:templateId': {
    nodeDataPath: '/data/feedback/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return feedbackPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: ['orderId', 'templateId'],
    cacheTags: ['feedback'],
  },
  '/store-purchase-returns': {
    nodeDataPath: '/data/store-purchase-returns',
    wcsDataPath: false,
    acceptedQueryParameters: [],
    cacheTags: ['returns'],
  },
  '/events/:eventId': {
    nodeDataPath: '/data/events/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return eventsPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: [],
    cacheTags: ['events'],
  },
  '/member/subscriptions': {
    nodeDataPath: '/data/member/subscriptions',
    wcsDataPath: '/webapp/wcs/stores/servlet/subscriptions?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: ['orderItemId', 'quantity', 'cancel', 'orderId', 'frequency', 'delay', 'newNextOrderDate'],
    cacheTags: [],
  },
  '/stores/:name/:storeNum': {
    nodeDataPath: '/data/stores/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/StoreDisplay?langId=-1&catalogId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['stores'],
  },
  '/stores/:stateName/:name/:storeNum': {
    nodeDataPath: '/data/stores/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/StoreDisplay?langId=-1&catalogId=-1&storeId=301',
    acceptedQueryParameters: [],
    cacheTags: ['stores'],
  },
  '/p/:name/:productId': {
    nodeDataPath: '/data/p/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/product_node-product-page_301_-1_301',
    OLDwcsDataPath: '/webapp/wcs/stores/servlet/ProductDisplay?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: ['forceDatabase'],
    cacheTags: ['product'],
  },
  '/p/:name/:productId/outfit': {
    nodeDataPath: '/data/p/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/product_node-product-page_301_-1_301?outfitPage=Y',
    OLDwcsDataPath: '/webapp/wcs/stores/servlet/ProductDisplay?catalogId=301&langId=-1&storeId=301&outfitPage=Y',
    acceptedQueryParameters: ['forceDatabase'],
    cacheTags: ['product', 'outfit'],
  },
  '/p/:name/:productId/sale': {
    nodeDataPath: '/data/p/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/product_node-product-page_301_-1_301?salePage=Y',
    OLDwcsDataPath: '/webapp/wcs/stores/servlet/ProductDisplay?catalogId=301&langId=-1&storeId=301&salePage=Y',
    acceptedQueryParameters: ['forceDatabase'],
    cacheTags: ['product', 'saleproduct'],
  },
  '/chanel/c/:pathToken': {
    nodeDataPath: '/data/chanel/c/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return contentPageWCSPathGeneratorChanel(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['chanel'],
  },
  '/c/:pathToken': {
    nodeDataPath: '/data/c/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return contentPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['cat'],
  },
  '/c/:pathToken/:pathModifier': {
    nodeDataPath: '/data/c/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return contentPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['cat'],
  },
  '/c/:pathToken/:pathModifier/:color': {
    nodeDataPath: '/data/c/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return contentPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['cat'],
  },
  '/c/:pathPrefix/:pathToken/:pathModifier/:color': {
    nodeDataPath: '/data/c/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return contentPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['cat'],
  },
  '/brand/sale-clearance/:manufacturer': {
    nodeDataPath: '/data/brand/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return brandPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/brand/sale-clearance/:manufacturer/:categoryName': {
    nodeDataPath: '/data/brand/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return brandPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/brand/sale-clearance/:manufacturer/:categoryName/:pathModifier': {
    nodeDataPath: '/data/brand/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return brandPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/brand/:manufacturer': {
    nodeDataPath: '/data/brand/*',
    wcsDataPath: '/webapp/wcs/stores/servlet/SearchDisplay?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/brand/:manufacturer/:categoryName': {
    nodeDataPath: '/data/brand/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return brandPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/brand/:manufacturer/:categoryName/:pathModifier': {
    nodeDataPath: '/data/brand/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return brandPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['brand'],
  },
  '/search-term/:searchTerm': {
    nodeDataPath: '/data/search-term/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return searchPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['search'],
    wcsSkipPathVariables: true,
  },
  '/search-term/:searchTerm/:categoryName': {
    nodeDataPath: '/data/search-term/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return searchPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['search'],
    wcsSkipPathVariables: true,
  },
  '/search-term/:searchTerm/:categoryName/:pathModifier': {
    nodeDataPath: '/data/search-term/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return searchPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['search'],
    wcsSkipPathVariables: true,
  },
  '/search-term/:pathToken/:searchTerm/:categoryName/:pathModifier': {
    nodeDataPath: '/data/search-term/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return searchPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: navPageParamList,
    cacheTags: ['search'],
    wcsSkipPathVariables: true,
  },
  '/oss': {
    nodeDataPath: '/data/oss',
    wcsDataPath: '/webapp/wcs/stores/servlet/OurStylistSuggestView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: ['catentryId', 'dept', 'mic'],
    cacheTags: ['product', 'oss'],
  },
  '/collections': {
    nodeDataPath: '/data/collections',
    wcsDataPath: '/webapp/wcs/stores/servlet/CollectionsView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: ['catentryId', 'dept', 'mic'],
    cacheTags: ['product', 'collections'],
  },
  '/personalizedProducts': {
    nodeDataPath: '/data/personalizedProducts',
    wcsDataPath: '/webapp/wcs/stores/servlet/PersonalizedProductsView?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: [
      'brandShortCode',
      'brandCode',
      'superCatId',
      'mfName',
      'orderBy',
      'productImageTemplate',
      'newArrivals',
      'json',
      'categoryCode',
      'dept',
      'mic',
      'sale',
      'minPercentOff',
      'minPrice',
      'maxPrice',
      'dillardsExclusive',
      'newArrivals',
      'backInStock',
      'limitedAvailability',
    ],
  },
  '/mobilemenu': {
    nodeDataPath: '/data/mobilemenu',
    wcsDataPath: '/webapp/wcs/stores/servlet/MobileMenu?catalogId=301&langId=-1&storeId=301',
    acceptedQueryParameters: ['category', 'excludeInactiveBrand'],
  },
  '/': {
    nodeDataPath: '/data',
    wcsDataPath: '/webapp/wcs/stores/servlet/topCategories_301_-1_301',
    acceptedQueryParameters: ['forceDatabase'],
    cacheTags: ['splash'],
  },
  '/member/wishlist': {
    nodeDataPath: '/data/member/wishlist',
    wcsDataPath: '/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1',
    acceptedQueryParameters: [],
    cacheTags: ['wishlist'],
    timeout: 90000,
  },
  '/member/shared-wishlist': {
    nodeDataPath: '/data/member/shared-wishlist',
    wcsDataPath: '/webapp/wcs/stores/servlet/SharedWishListView?storeId=301&catalogId=301&langId=-1',
    acceptedQueryParameters: ['listId'],
    cacheTags: ['wishlist'],
    timeout: 90000,
  },
  '/member/manage-dillards-card': {
    nodeDataPath: '/data/member/manage-dillards-card',
    wcsDataPath: false,
    acceptedQueryParameters: [],
    cacheTags: ['manage-dillards-card'],
  },
  '/checkout/phone-orders/:orderID': {
    nodeDataPath: '/data/checkout/phone-orders/*',
    wcsDataPathFunction: (keys, resolvedPathVariables) => {
      return phoneOrderCheckoutPageWCSPathGenerator(keys, resolvedPathVariables);
    },
    acceptedQueryParameters: [],
    cacheTags: ['phoneOrderCheckout'],
  },
  '/error/:status': {
    nodeDataPath: '/data/error',
    wcsDataPath: false,
    acceptedQueryParameters: [],
    cacheTags: ['error'],
  },
};

function feedbackPageWCSPathGenerator(keys, resolvedPathVariables) {
  const tempId = resolvedPathVariables[1];
  return `/wcs/resources/store/301/survey/template/${tempId}`;
}

function eventsPageWCSPathGenerator(keys, resolvedPathVariables) {
  const eventId = resolvedPathVariables[1];
  return `/wcs/resources/store/301/event/${eventId}/stores`;
}

function phoneOrderCheckoutPageWCSPathGenerator(keys, resolvedPathVariables) {
  const orderId = resolvedPathVariables[1];
  return `/wcs/resources/store/301/checkout/rsv/order/${orderId}`;
}

function contentPageWCSPathGeneratorChanel(keys, resolvedPathVariables) {
  var pathToken = '';
  for (var iKeys = 0; iKeys < keys.length; iKeys++) {
    if (keys[iKeys].name == 'pathToken') {
      pathToken = resolvedPathVariables[iKeys + 1];
    }
  }

  return `/webapp/wcs/stores/servlet/en/chanel/${pathToken}?catalogId=301&langId=-1&storeId=301`;
}
function contentPageWCSPathGenerator(keys, resolvedPathVariables) {
  // Extract variables from keys and resolvedPathVariables
  const getPathVariable = (keyName) => {
    const index = keys.findIndex((k) => k.name === keyName);
    return index !== -1 ? resolvedPathVariables[index + 1] : '';
  };
  let prefix = getPathVariable('pathPrefix');
  let pathToken = getPathVariable('pathToken');
  let pathModifier = getPathVariable('pathModifier');
  let _unused_color = getPathVariable('color');

  /**
   * http://localhost/c/shopbybrand
   * http://localhost/c/shopbybrand/men
   */
  if (pathToken === 'shopbybrand') {
    return `/webapp/wcs/stores/servlet/en/dillards/shopbybrand?catalogId=301&langId=-1&storeId=301&categoryName=${pathModifier}&sale=${_unused_color}`;
  }

  /**
   * https://localhost/c/women
   * https://localhost/c/limited-availability
   * https://localhost/c/sale-clearance
   * https://localhost/c/back-in-stock
   */
  if (pathModifier === '') {
    return `/webapp/wcs/stores/servlet/en/dillards/${pathToken}?catalogId=301&langId=-1&storeId=301`;
  }

  if (!prefix) {
    if (
      pathToken === 'limited-availability' ||
      pathToken === 'sale-clearance' ||
      pathToken.startsWith('clearance-') ||
      pathToken === 'back-in-stock'
    ) {
      [prefix, pathToken, pathModifier] = [pathToken, pathModifier, _unused_color];
    }
  }

  // Facets for seo prefixes
  const facets = {
    'limited-availability': () => 'catenttype_id_ntk_cs:(BundleBean ItemBean) AND dil_ptag_limited_availability:*',
    'clearance-65': () =>
      `catenttype_id_ntk_cs:(BundleBean ItemBean) AND dil_pricereduced_percentage_max:[64.500 TO *]`,
    'back-in-stock': () => `dil_back_in_stock:Y`,
  };

  let query = '';
  if (prefix === 'sale-clearance') {
    if (pathToken === 'back-in-stock') {
      query =
        '&facet=catenttype_id_ntk_cs:(BundleBean ItemBean) AND dil_pricereduced_percentage_max:[0.500 TO *] AND dil_back_in_stock:Y';
      [pathToken, pathModifier] = [pathModifier, _unused_color];
    } else if (pathToken === 'limited-availability') {
      query =
        '&facet=catenttype_id_ntk_cs:(BundleBean ItemBean) AND dil_pricereduced_percentage_max:[0.500 TO *] AND dil_ptag_limited_availability:*';
      [pathToken, pathModifier] = [pathModifier, _unused_color];
    } else {
      query = `&facet=catenttype_id_ntk_cs:(BundleBean ItemBean) AND dil_pricereduced_percentage_max:[0.500 TO *]`;
    }
  } else if (facets[prefix]) {
    const facet = facets[prefix]();
    query = `&facet=${facet}`;
  } else if (prefix.startsWith('clearance-')) {
    const clearancePercentage = parseInt(prefix.replace('clearance-', ''));
    const minPercentage = clearancePercentage - 1;
    const maxPercentage = clearancePercentage;

    query = `&facet=dil_pricereduced_percentage_max:[${minPercentage}.500 TO ${maxPercentage}.499]&percentOff=${clearancePercentage}`;
  }

  let returnWCSPath = `/webapp/wcs/stores/servlet/en/dillards/${pathToken}?catalogId=301&langId=-1&storeId=301&${query}`;

  if (pathModifier === 'outfits') {
    returnWCSPath += `&outfitPage=Y`;
  } else if (pathModifier) {
    returnWCSPath += `&seoColor=${pathModifier}`;
    _unused_color = pathModifier;
  }

  return returnWCSPath;
}

function brandPageWCSPathGenerator(keys, resolvedPathVariables) {
  var pathModifier = '';
  for (var iKeys = 0; iKeys < keys.length; iKeys++) {
    if (keys[iKeys].name == 'pathModifier') {
      pathModifier = resolvedPathVariables[iKeys + 1];
    }
  }
  if ('outfits' == pathModifier) {
    return `/webapp/wcs/stores/servlet/SearchDisplay?catalogId=301&langId=-1&storeId=301&outfitPage=Y`;
  }
  let returnWCSPath = `/webapp/wcs/stores/servlet/SearchDisplay?catalogId=301&langId=-1&storeId=301&seoColor=${pathModifier}`;
  if (resolvedPathVariables[0].startsWith('/brand/sale-clearance/')) {
    returnWCSPath += '&facet=dil_pricereduced:"1"';
  }
  return returnWCSPath;
}

/**
 * Generates WCS path for search page based on input keys and resolved path variables.
 *
 * @param {Array<Object>} keys - Array of objects containing key information (e.g., { name: 'pathToken' })
 * @param {Array<string>} resolvedPathVariables - Array of resolved variable values corresponding to `keys`
 * @returns {string} Generated WCS path
 */
function searchPageWCSPathGenerator(keys, resolvedPathVariables) {
  const baseUri = '/webapp/wcs/stores/servlet/SearchDisplay';

  const getPathVariable = (keyName) => {
    const index = keys.findIndex((k) => k.name === keyName);
    return index !== -1 ? resolvedPathVariables[index + 1] : '';
  };

  let pathModifier = getPathVariable('pathModifier');
  let categoryName = getPathVariable('categoryName');
  let searchTerm = getPathVariable('searchTerm');
  let pathToken = getPathVariable('pathToken');

  /**
   * We do a parameter shifting to handle sale-clearance prefix on search-term
   *
   * /search-term/:searchTerm
   * /search-term/:searchTerm/:categoryName
   * /search-term/:searchTerm/:categoryName/:pathModifier
   * /search-term/:pathToken/:searchTerm/:categoryName/:pathModifier
   */
  if (searchTerm === 'sale-clearance' && categoryName) {
    [searchTerm, categoryName, pathModifier, pathToken] = [categoryName, pathModifier, pathToken, 'sale-clearance'];
  }

  const queryParams = {
    catalogId: 301,
    langId: -1,
    storeId: 301,
    searchTerm,
    categoryName,
    pathModifier,
    facet: pathToken === 'sale-clearance' ? encodeURIComponent('dil_pricereduced:"1"') : '',
  };

  if (pathModifier === 'outfits') {
    queryParams.outfitPage = 'Y';
  } else if (pathModifier) {
    queryParams.seoColor = pathModifier;
  }

  const queryString = Object.keys(queryParams)
    .reduce((acc, key) => {
      const value = queryParams[key];
      if (value !== undefined && value !== '') {
        acc.push(`${key}=${value}`);
      }
      return acc;
    }, [])
    .join('&');

  const returnWCSPath = `${baseUri}${queryString ? '?' + queryString : ''}`;

  return returnWCSPath;
}

var cookiePassNodePaths = pathConfig.cookiePassNodePathsInOrder;
var nodePaths = pathConfig.nodePathsInOrder.concat(cookiePassNodePaths);
var nodeDataPaths = [];
for (var i = 0; i < nodePaths.length; i++) {
  nodeDataPaths.push(pathConfig[nodePaths[i]].nodeDataPath);
}

cookiePassNodePaths = pathConfig.cookiePassNodePathsInOrder;
var cookiePassNodeDataPaths = [];
for (i = 0; i < cookiePassNodePaths.length; i++) {
  cookiePassNodeDataPaths.push(pathConfig[cookiePassNodePaths[i]].nodeDataPath);
}

var oneDataCall = false;

//This is currently covering the transition between old style hash urls and the new actual facet param calls.  Ideally this will go away, but I don't see that happening for a while.
var facetCovering = {
  facetKeys: [
    'dil_newArrival',
    'ads_f11008_ntk_cs',
    'mfName_ntk_cs',
    'ads_f13003_ntk_cs',
    'ads_f10525_ntk_cs',
    'ads_f11001_ntk_cs',
    'ads_f10543_ntk_cs',
    'ads_f10529_ntk_cs',
    'ads_f10523_ntk_cs',
    'ads_f10522_ntk_cs',
    'ads_f10514_ntk_cs',
    'ads_f13009_ntk_cs',
    'ads_f10516_ntk_cs',
  ],
  dil_newArrival: [['1000149', '1']],
  ads_f11008_ntk_cs: [
    ['-101495247495377', '14%2F15M'],
    ['-10154475577', '6%2F7M'],
    ['-101578887', '9XW'],
    ['-1015646538887', '8.5XW'],
    ['-1015746538887', '9.5XW'],
    ['-10149488887', '10XW'],
    ['-101494946538887', '11.5XW'],
    ['-10149508887', '12XW'],
    ['-10149518887', '13XW'],
    ['-10149538787', '15WW'],
    ['-10149548787', '16WW'],
    ['-1014951696969', '13EEE'],
    ['-101495278', '14N'],
    ['-1014953696969', '15EEE'],
    ['-101495377', '15M'],
    ['-1014954696969', '16EEE'],
    ['-1015157', '39'],
    ['-1015248', '40'],
    ['-1015255', '47'],
    ['-1015257', '49'],
    ['-101554755465377', '7%2F7.5M'],
    ['-1014949696969', '11EEE'],
    ['-10149498887', '11XW'],
    ['-1014949465365', '11.5A'],
    ['-1014949465366', '11.5B'],
    ['-10149494653696969', '11.5EEE'],
    ['-101495065', '12A'],
    ['-101495066', '12B'],
    ['-1014950696969', '12EEE'],
    ['-101495165', '13A'],
    ['-101495166', '13B'],
    ['-101574653696969', '9.5EEE'],
    ['-101494865', '10A'],
    ['-101494866', '10B'],
    ['-1014948696969', '10EEE'],
    ['-1014948465366', '10.5B'],
    ['-10149484653696969', '10.5EEE'],
    ['-101494846538887', '10.5XW'],
    ['-101494965', '11A'],
    ['-101494966', '11B'],
    ['-1015569', '7E'],
    ['-10155696969', '7EEE'],
    ['-10156696969', '8EEE'],
    ['-101568887', '8XW'],
    ['-101564653696969', '8.5EEE'],
    ['-1015765', '9A'],
    ['-1015766', '9B'],
    ['-10157696969', '9EEE'],
    ['-10157465365', '9.5A'],
    ['-10157465366', '9.5B'],
    ['-1015468', '6D'],
    ['-10154696969', '6EEE'],
    ['-10154465368', '6.5D'],
    ['-101544653696969', '6.5EEE'],
    ['-10156465377', '8.5M'],
    ['-1015777', '9M'],
    ['-10157465377', '9.5M'],
    ['-101494877', '10M'],
    ['-1015477', '6M'],
    ['-10154465377', '6.5M'],
    ['-1015677', '8M'],
    ['-10149', '1'],
    ['-10151', '3'],
    ['-10153', '5'],
    ['-10157', '9'],
    ['-1014949', '11'],
    ['-1014951', '13'],
    ['-1014953', '15'],
    ['-1014952696969', '14EEE'],
    ['-101495477', '16M'],
    ['-101495577', '17M'],
    ['-101495677', '18M'],
    ['-1015348', '50'],
    ['-101495366', '15B'],
    ['-101495368', '15D'],
    ['-101495466', '16B'],
    ['-101495468', '16D'],
    ['-101495387', '15W'],
    ['-101495487', '16W'],
    ['-10149528787', '14WW'],
    ['-1015577', '7M'],
    ['-101554653696969', '7.5EEE'],
    ['-1015256', '48'],
    ['-101495268', '14D'],
    ['-101495266', '14B'],
    ['-101495265', '14A'],
    ['-1015154', '36'],
    ['-1015568', '7D'],
    ['-10155465377', '7.5M'],
    ['-10155465368', '7.5D'],
    ['-10155465369', '7.5E'],
    ['-1014948', '10'],
    ['-10176', 'L'],
    ['-1014950', '12'],
    ['-1014952', '14'],
    ['-1014954', '16'],
    ['-1017810111998111114110', 'Newborn'],
    ['-10180114101101109105101', 'Preemie'],
    ['-1018883', 'XS'],
    ['-1018876', 'XL'],
    ['-10148', '0'],
    ['-10150', '2'],
    ['-10183', 'S'],
    ['-10152', '4'],
    ['-10154', '6'],
    ['-10177', 'M'],
    ['-10156', '8'],
    ['-10153465387', '5.5W'],
    ['-1014949465383', '11.5S'],
    ['-101495083', '12S'],
    ['-1015252', '44'],
    ['-1015177', '3M'],
    ['-101495277', '14M'],
    ['-101495287', '14W'],
    ['-1015546538383', '7.5SS'],
    ['-10155465383', '7.5S'],
    ['-101568383', '8SS'],
    ['-1015683', '8S'],
    ['-1015646538383', '8.5SS'],
    ['-10156465383', '8.5S'],
    ['-1015783', '9S'],
    ['-1015746538383', '9.5SS'],
    ['-10157465383', '9.5S'],
    ['-10149488383', '10SS'],
    ['-101494883', '10S'],
    ['-101494846538383', '10.5SS'],
    ['-1014948465383', '10.5S'],
    ['-10149498383', '11SS'],
    ['-101494983', '11S'],
    ['-1014949465378', '11.5N'],
    ['-1014949465387', '11.5W'],
    ['-101494946538787', '11.5WW'],
    ['-101495178', '13N'],
    ['-1015387', '5W'],
    ['-101494846538787', '10.5WW'],
    ['-101494977', '11M'],
    ['-101494978', '11N'],
    ['-101494987', '11W'],
    ['-10149498787', '11WW'],
    ['-1014949465377', '11.5M'],
    ['-101495077', '12M'],
    ['-101495078', '12N'],
    ['-101495087', '12W'],
    ['-10149508787', '12WW'],
    ['-101495187', '13W'],
    ['-1015153', '35'],
    ['-1015249', '41'],
    ['-1015250', '42'],
    ['-101558383', '7SS'],
    ['-1015583', '7S'],
    ['-101578383', '9SS'],
    ['-1015377', '5M'],
    ['-10153465377', '5.5M'],
    ['-1015478', '6N'],
    ['-1015487', '6W'],
    ['-10154465378', '6.5N'],
    ['-10154465387', '6.5W'],
    ['-1015446538787', '6.5WW'],
    ['-10155465387', '7.5W'],
    ['-1015546538787', '7.5WW'],
    ['-1015678', '8N'],
    ['-101568787', '8WW'],
    ['-1015687', '8W'],
    ['-10156465378', '8.5N'],
    ['-10156465387', '8.5W'],
    ['-1015646538787', '8.5WW'],
    ['-10157465387', '9.5W'],
    ['-1015746538787', '9.5WW'],
    ['-101494878', '10N'],
    ['-101494887', '10W'],
    ['-10149488787', '10WW'],
    ['-1014948465377', '10.5M'],
    ['-1014948465378', '10.5N'],
    ['-1014948465387', '10.5W'],
    ['-101495177', '13M'],
    ['-101548787', '6WW'],
    ['-1015578', '7N'],
    ['-1015587', '7W'],
    ['-101558787', '7WW'],
    ['-1015778', '9N'],
    ['-10155465378', '7.5N'],
    ['-1015787', '9W'],
    ['-101578787', '9WW'],
    ['-10157465378', '9.5N'],
    ['-1015277', '4M'],
    ['-10152465377', '4.5M'],
  ],
  mfName_ntk_cs: [
    ['-100266114105971103265116119111111100', 'Brian+Atwood'],
    ['-100284114111116116101114115', 'Trotters'],
    ['-100276111117105115101321011163267105101', 'Louise+et+Cie'],
    ['-10027411710599101326610197117116121', 'Juice+Beauty'],
    ['-10027597116104101114105110101326711111510910111610599115', 'Katherine+Cosmetics'],
    ['-1002857171', 'UGG'],
    ['-10028610511111010599', 'Vionic'],
    ['-100266122101101115', 'Bzees'],
    ['-1002831111021168797108107', 'SoftWalk'],
    ['-100266105108108326610897115115', 'Bill+Blass'],
    ['-100280971171083271114101101110', 'Paul+Green'],
    ['-1002711089710971108111119', 'GlamGlow'],
    ['-100283105109112108101328311710397114115', 'Simple+Sugars'],
    ['-100289857873', 'YUNI'],
    ['-1002881159997112101', 'Xscape'],
    ['-100265114116105115', 'Artis'],
    ['-10027446328111710110111032781011193289111114107', 'J.+Queen+New+York'],
    ['-10028010511210111432383287114105103104116', 'Piper+%2526+Wright'],
    ['-1002821111151013284114101101', 'Rose+Tree'],
    ['-10028610111497116101120', 'Veratex'],
    ['-10028610510810897329812132781119810810132691209910110810810111099101', 'Villa+by+Noble+Excellence'],
    ['-10028797116101114102111114100', 'Waterford'],
    ['-100282971141013269100105116105111110115', 'Rare+Editions'],
    ['-10026811111011097327711111410397110', 'Donna+Morgan'],
    ['-10026510510097110327797116116111120', 'Aidan+Mattox'],
    ['-1002679799104101116', 'Cachet'],
    ['-1002679711410910111032779711499328697108118111', 'Carmen+Marc+Valvo'],
    ['-10027483326711110810810199116105111110115', 'JS+Collections'],
    ['-100275971213285110103101114', 'Kay+Unger'],
    ['-10028610597328311210510397', 'Via+Spiga'],
    ['-1002671049711011610510810812132801089799101', 'Chantilly+Place'],
    ['-100269100103101104105108108326711110810810199116105111110', 'Edgehill+Collection'],
    ['-100270101108116109971103266114111116104101114115', 'Feltman+Brothers'],
    ['-100270114105101100107110105116326711410197116105111110115', 'Friedknit+Creations'],
    ['-10027497121110101326711111210110897110100', 'Jayne+Copeland'],
    ['-100274111971103267971089798114101115101', 'Joan+Calabrese'],
    ['-1002801051121129732383274117108105101', 'Pippa+%2526+Julie'],
    ['-10026711112197326711110810810199116105111110', 'Coya+Collection'],
    ['-1002711089710911111711432981213284101114971101053267111117116117114101', 'Glamour+by+Terani+Couture'],
    ['-1002741051081083274105108108328311611797114116', 'Jill+Jill+Stuart'],
    ['-1002744679466546', 'J.O.A.'],
    ['-1002769711711010011412132981213283104101108108105328310110397108', 'Laundry+by+Shelli+Segal'],
    ['-10027611799121328097114105115', 'Lucy+Paris'],
    ['-100277971031031213276111110100111110', 'Maggy+London'],
    ['-10028311710397114108105112115', 'Sugarlips'],
    ['-10024946328384658469', '1.+STATE'],
    ['-1002671041011081151019732383286105111108101116', 'Chelsea+%2526+Violet'],
    ['-10026747776979', 'C%2FMEO'],
    ['-100270111120105101100111120', 'Foxiedox'],
    ['-100272327297108115116111110', 'H+Halston'],
    ['-10027810599111108101327710510810810111432781011193289111114107', 'Nicole+Miller+New+York'],
    ['-10027510110111211597107101', 'Keepsake'],
    ['-10027311897110107973284114117109112', 'Ivanka+Trump'],
    ['-100268971181051003277101105115116101114', 'David+Meister'],
    ['-100275111114107456997115101', 'Kork-Ease'],
    ['-10028211199107112111114116', 'Rockport'],
    ['-10027597115112101114', 'Kasper'],
    ['-100284971049711410532658376', 'Tahari+ASL'],
    ['-10026711111511697', 'Costa'],
    ['-100277971171053274105109', 'Maui+Jim'],
    ['-10027997107108101121', 'Oakley'],
    ['-10028311111711610410111411032701141051011003267111116116111110', 'Southern+Fried+Cotton'],
    ['-1002831111171161041011141103276117114101', 'Southern+Lure'],
    ['-10026911897328697114114111', 'Eva+Varro'],
    ['-100277105110103328797110103', 'Ming+Wang'],
    ['-100277105115111111107', 'Misook'],
    ['-100266111110110105101327410197110', 'Bonnie+Jean'],
    ['-10028297108112104328297108112104327697117114101110', 'Ralph+Ralph+Lauren'],
    ['-100267388632671041011081151019732383286105111108101116', 'C%2526V+Chelsea+%2526+Violet'],
    ['-1002771051151153277101', 'Miss+Me'],
    ['-10028310111011511111411210110010599', 'Sensorpedic'],
    ['-100278896874', 'NYDJ'],
    ['-100269115116101101327697117100101114', 'Estee+Lauder'],
    ['-10027497991073282111103101114115', 'Jack+Rogers'],
    ['-10027211111010112132971101003282111115105101', 'Honey+and+Rosie'],
    ['-10026646326897114108105110', 'B.+Darlin'],
    ['-1002841011011221013277101', 'Teeze+Me'],
    ['-1002734678463283971103270114971109910511599111', 'I.N.+San+Francisco'],
    ['-100274117109112', 'Jump'],
    ['-100267114101109105101117120', 'Cremieux'],
    ['-1002999711010010599101327976837978', 'candice+OLSON'],
    ['-1002671111121121011143275101121', 'Copper+Key'],
    ['-1002731031101051161013269118101110105110103115', 'Ignite+Evenings'],
    ['-1002779711410511097', 'Marina'],
    ['-10026510510097110326510510097110327797116116111120', 'Aidan+Aidan+Mattox'],
    ['-1002661011003283116117', 'Bed+Stu'],
    ['-100269109109973283116114101101116', 'Emma+Street'],
    ['-100267971081181051103275108101105110', 'Calvin+Klein'],
    ['-1002761013266111115', 'Le+Bos'],
    ['-100266826572777378', 'BRAHMIN'],
    ['-10027610111810539115', 'Levi%27s'],
    ['-10027597114101110327597110101', 'Karen+Kane'],
    ['-1002651181019932761011153270105108108101115', 'Avec+Les+Filles'],
    ['-10027411110139115327410197110115', 'Joe%27s+Jeans'],
    ['-100275858432102114111109321161041013275108111116104', 'KUT+from+the+Kloth'],
    ['-100283971109911611797114121', 'Sanctuary'],
    ['-10027011410111099104326711111011010199116105111110', 'French+Connection'],
    ['-10026610110810810132669710010310810112132771051159910410797', 'Belle+Badgley+Mischka'],
    ['-100280101110100108101116111110', 'Pendleton'],
    ['-1002831161171001051113268', 'Studio+D'],
    ['-1002781119810810132691209910110810810111099101', 'Noble+Excellence'],
    ['-1002711179999105', 'Gucci'],
    ['-10027410197110328097117108327197117108116105101114', 'Jean+Paul+Gaultier'],
    ['-1002741051091091213267104111111', 'Jimmy+Choo'],
    ['-1002801149710097', 'Prada'],
    ['-100271105111114103105111326511410997110105', 'Giorgio+Armani'],
    ['-10028479773270798268', 'TOM+FORD'],
    ['-1002861011141159799101', 'Versace'],
    ['-10026679838332721171031113266111115115', 'BOSS+Hugo+Boss'],
    ['-1002823238327732821059910497114100115', 'R+%2526+M+Richards'],
    ['-10028397107114111111116115', 'Sakroots'],
    ['-100270114121101', 'Frye'],
    ['-100289118101115328397105110116327697117114101110116', 'Yves+Saint+Laurent'],
    ['-10028097991113282979897110110101', 'Paco+Rabanne'],
    ['-100266111116107105101114', 'Botkier'],
    ['-100270111115115105108', 'Fossil'],
    ['-10028610510711611111432383282111108102', 'Viktor+%2526+Rolf'],
    ['-10026611810810397114105', 'Bvlgari'],
    ['-10028610111497326611497100108101121', 'Vera+Bradley'],
    ['-1002831111171161041011141103276105118105110103', 'Southern+Living'],
    ['-10028297108112104327697117114101110', 'Ralph+Lauren'],
    ['-10027010511612232971101003270108111121100', 'Fitz+and+Floyd'],
    ['-1002771171003280105101', 'Mud+Pie'],
    ['-100280971141073272105108108', 'Park+Hill'],
    ['-1002651081011203269118101110105110103115', 'Alex+Evenings'],
    ['-1002741079711497', 'Jkara'],
    ['-100284114105110973284117114107', 'Trina+Turk'],
    ['-100284101114971101053267111117116117114101', 'Terani+Couture'],
    ['-10026910897110', 'Elan'],
    ['-100267108105110105113117101', 'Clinique'],
    ['-10026910810512297981011161043265114100101110', 'Elizabeth+Arden'],
    ['-10027111710111410897105110', 'Guerlain'],
    ['-100279114105103105110115', 'Origins'],
    ['-100283104105115101105100111', 'Shiseido'],
    ['-10026811111111010112132383266111117114107101', 'Dooney+%2526+Bourke'],
    ['-100280971161141059910597327897115104', 'Patricia+Nash'],
    ['-100278105107101', 'Nike'],
    ['-10028497100971151041053283104111106105', 'Tadashi+Shoji'],
    ['-10027410111511510599973283105109112115111110', 'Jessica+Simpson'],
    ['-1002841111091091213266971049710997', 'Tommy+Bahama'],
    ['-100268105111114', 'Dior'],
    ['-10026611198981053266114111119110', 'Bobbi+Brown'],
    ['-100275105101104108391153283105110991013249565349', 'Kiehl%27s+Since+1851'],
    ['-1002769711099111109101', 'Lancome'],
    ['-1002776567', 'MAC'],
    ['-10026711199111328297118101', 'Coco+Rave'],
    ['-10027166', 'GB'],
    ['-100265683238326897117103104116101114115', 'AD+%2526+Daughters'],
    ['-100265108101120327797114105101', 'Alex+Marie'],
    ['-100265110116111110105111327710110897110105', 'Antonio+Melani'],
    ['-10026779656772', 'COACH'],
    ['-1002691051081011011103270105115104101114', 'Eileen+Fisher'],
    ['-100280111108111328297108112104327697117114101110', 'Polo+Ralph+Lauren'],
    ['-10026710897114105110115', 'Clarins'],
    ['-10026711110910211111411610511897', 'Comfortiva'],
    ['-10026897110115107111', 'Dansko'],
    ['-100269676779', 'ECCO'],
    ['-10027010511670108111112', 'FitFlop'],
    ['-100271101111120', 'Geox'],
    ['-10027311511110897', 'Isola'],
    ['-1002749710998117', 'Jambu'],
    ['-100274111115101102328310110598101108', 'Josef+Seibel'],
    ['-100277101112104105115116111', 'Mephisto'],
    ['-10027897111116', 'Naot'],
    ['-100278117114116117114101', 'Nurture'],
    ['-10028211110910510797', 'Romika'],
    ['-100283111102102116', 'Sofft'],
    ['-10028497111115327011111111611910197114', 'Taos+Footwear'],
    ['-10027710599104971011083275111114115', 'Michael+Kors'],
    ['-1002651001141059711011097328097112101108108', 'Adrianna+Papell'],
    ['-100269108105122973274', 'Eliza+J'],
    ['-1002741011151151059997327211111997114100', 'Jessica+Howard'],
    ['-10027697117114101110328297108112104327697117114101110', 'Lauren+Ralph+Lauren'],
    ['-10028610511099101326797109117116111', 'Vince+Camuto'],
    ['-1002789711611711497108105122101114', 'Naturalizer'],
    ['-1002669710010310810112132771051159910410797', 'Badgley+Mischka'],
    ['-100274463282101110101101', 'J.+Renee'],
    ['-100277736772656976327710599104971011083275111114115', 'MICHAEL+Michael+Kors'],
    ['-10028397109326910010110810997110', 'Sam+Edelman'],
    ['-100271105971101101053266105110105', 'Gianni+Bini'],
    ['-1002661011161151011213274111104110115111110', 'Betsey+Johnson'],
    ['-10026510810110311410597', 'Alegria'],
    ['-10026610511410710111011511611199107', 'Birkenstock'],
    ['-100266111114110', 'Born'],
    ['-10021079711610132115112971001013211010111932121111114107', 'kate+spade+new+york'],
  ],
  ads_f13003_ntk_cs: [
    ['-1748497108108', 'Tall'],
    ['-1747911810111432841041013275110101101', 'Over+The+Knee'],
  ],
  ads_f10525_ntk_cs: [['-2458497110107', 'Tank']],
  ads_f11001_ntk_cs: [
    ['-1196511010510997108', 'Animal'],
    ['-11977117108116105477710511599', 'Multi%2FMisc'],
    ['-1197010811111497108', 'Floral'],
    ['-11980117114112108101', 'Purple'],
    ['-11971114101121', 'Grey'],
    ['-1198497110', 'Tan'],
    ['-11980105110107', 'Pink'],
    ['-11966108117101', 'Blue'],
    ['-11982101100', 'Red'],
    ['-11973118111114121', 'Ivory'],
    ['-11971111108100', 'Gold'],
    ['-11983105108118101114', 'Silver'],
    ['-11971114101101110', 'Green'],
    ['-11989101108108111119', 'Yellow'],
    ['-11987104105116101', 'White'],
    ['-119661089799107', 'Black'],
  ],
  ads_f10543_ntk_cs: [['-31083107105110110121', 'Skinny']],
  ads_f10529_ntk_cs: [
    ['-1325147523283108101101118101', '3%2F4+Sleeve'],
    ['-132761111101033283108101101118101', 'Long+Sleeve'],
  ],
  ads_f10523_ntk_cs: [['-2186610897122101114', 'Blazer']],
  ads_f10522_ntk_cs: [['-1986697108108103111119110', 'Ballgown']],
  ads_f10514_ntk_cs: [
    ['-19784101973276101110103116104476697108108101116', 'Tea+Length%2FBallet'],
    ['-197661011081111193275110101101', 'Below+Knee'],
    ['-19765981111181013275110101101', 'Above+Knee'],
    ['-19777105110105', 'Mini'],
    ['-197751101011013276101110103116104', 'Knee+Length'],
  ],
  ads_f13009_ntk_cs: [['-241801011011123284111101', 'Peep+Toe']],
  ads_f10516_ntk_cs: [['-16283104111114116', 'Short']],
};

//Should the call for headerFooterData to commerce bomb, this will be used.
//This can happen if commerce can not be communicated with or if the json object for the headerFooterData is malformed.  Both have happened.
//This should probably be updated periodically with a good set of defaults with the exception of probably excluding the header promo contents.
var fallbackHeaderFooterJSON = {
  JSON: {
    wasParms: {
      cacheCallVariable: '-1',
      fontCacheCallVariable: '31',
      domainName: 'www.dillards.com',
      solrDomainName: 'isolrprod.dillards.com:3737',
      powerReviewsAPIKey: 'e17667f7-827b-4880-8fe1-ab55b0a692b9',
      powerReviewsMerchantId: '689225',
      powerReviewsMerchantGroupId: '13763',
      isSaleDay: 'false',
      isPreviewDay: 'false',
      isPersonalizationOn: 'true',
      myFavorites: 'true',
      isMiniCartPopoutOn: 'true',
      isTypeAhead: 'true',
      displayOurStylistSuggests: 'true',
      displayCollections: 'true',
      useProductRecommendations: 'true',
      cartTimerTimeOutValue: '15',
      activateCartTimer: 'true',
      displayMonogram: 'false',
      defaultNavSort: '1',
      useAfterpay: 'true',
      afterpayMaxOrderAmt: '3000.00',
      bambuserEnabled: 'true',
      afterpayProductScript: 'https://js.afterpay.com/afterpay-1.x.js',
      payPalClientId: 'AVSdbaraA58612eLNBLL_asJRRkkF9t0L-zftqCX5L7iRa1JhtOmA_HMqKrxy7drE-bdxk72Dqr7thMj',
      isQuantumNetworkInterceptorEnabled: 'true',
      showFeedbackTab: 'true',
      generalFeedbackResetTime: '2592000000',
      postPurchaseFeedbackResetTime: '',
      displayStyliticsWidget: 'true',
      internationalShippingScript: 'https://hello.zonos.com/s/dillards_hello.js?siteKey=BHCX1AWJKM4G',
      bloomreachAccount_id: '7377',
      bloomreachAuth_key: 'dillards-3c96cf8c-b969-4756-812e-64d0904a52af',
      bloomreachDomain_key: 'dillards',
      isBloomreach: 'true',
      isBloomreachAutoSuggest: 'true',
      bloomreachPostProcessCategoryFacetLevelsList: '1,2,3,4',
      bloomreach_base_url: 'https://core.dxpapi.com/api/v1/core/',
      bloomreachAutoSuggestBaseUrl: 'https://suggest.dxpapi.com/api/v2/suggest/',
      bloomreachDisplayAllFacetsAtTopCatLevel: 'true',
      bloomreachCategoryDrilldownEnabled: 'true',
      bloomreachDefaultSortField: 'None',
      eventNumViewableMonths: '3',
      bloomreachAxiosTimeoutMilliseconds: '60000',
      radarKey: 'prj_live_pk_6c2c62684978429d1d4ac46cf83a30fd4113160e',
      personalizationCategoryIds: '430|410|445|440|892|898|890|470|435|480|450|420',
      personalizationPointsUpdateThreshold: '10',
      personalizationFavoriteBrandPointValue: '100',
      criteoTilesToOverride: '|9|12|15|18|',
      criteoTilesToOverrideMobile: '|6|8|10|12|',
      criteoSupersToInclude: '|420|445|435|410|450|470|425|440|430|480|',
      menuOrderCatIdAndName:
        "410|women,430|juniors,445|men,440|kids,892|women's shoes,890|men's shoes,898|kids' shoes,470|handbags,435|accessories,480|lingerie,450|home,420|beauty",
      citiSnapshotAvailability: 'true',
      citiDomainName: 'https://citiretailservices.citibankonline.com',
      citiSiteId: 'PLCN_DILLARDS',
      citiReturnURI: 'https://www.dillards.com/member/manage-dillards-card',
      allowFindInStore: 'false',
      findInStoreInstockQuantity: '3',
      imboxOnHandThreshold: '0',
      imboxBaseCharge: '7.00',
    },
    Mobile_Homepage_Categories:
      '<section class=#double;mobile-menu-categories hidden-sm hidden-md hidden-lg#double;>  <div class=#double;container p-0#double;>    <div class=#double;row mx-0#double;>      <div class=#double;col-12 p-0#double;>        <nav>      <ul class=#double;category-list#double;>    <li><a href=#double;/c/women?forceFlatResults=forceFlatResults#double;> Women </a></li>    <li class=#double;show-when-international#double;><a href=#double;/c/women-dresses?forceFlatResults=forceFlatResults#double;>Dresses </a></li>    <li><a href=#double;/c/juniors?forceFlatResults=forceFlatResults#double;>Juniors </a></li>     <li><a href=#double;/c/shoes?forceFlatResults=forceFlatResults#double;>Shoes </a></li>    <li><a href=#double;/c/handbags?forceFlatResults=forceFlatResults#double;>Handbags </a></li>    <li><a href=#double;/c/accessories?forceFlatResults=forceFlatResults#double;>Accessories </a></li>    <li><a href=#double;/c/lingerie?forceFlatResults=forceFlatResults#double;>Lingerie </a></li>    <li><a href=#double;/c/beauty?forceFlatResults=forceFlatResults#double;>Beauty </a></li>    <li><a href=#double;/c/men?forceFlatResults=forceFlatResults#double;>Men </a></li>    <li><a href=#double;/c/kids?forceFlatResults=forceFlatResults#double;>Kids </a></li>    <li><a href=#double;/c/home?forceFlatResults=forceFlatResults#double;>Home </a></li>            <li><a href=#double;/c/sale-clearance#double; class=#double;saleRed#double;>Sale and Clearance </a></li>            <li><a href=#double;/c/shopbybrand#double;>Shop By Brand </a></li>            <li><a href=#double;/c/limited-availability#double;  class=#double;limitedBlue#double;>Limited Availability </a></li>            <li class=#double;hide-when-international#double; id=#double;registryLink#double;><a href=#double;/registry#double; style=#double;color:#2cb0b0#double;>Registry</a></li>            <li class=#double;hide-when-international#double; id=#double;giftCardLink#double;><a href=#double;/c/giftcard#double;>Gift Cards</a></li>          </ul>        </nav>      </div>    </div>  </div></section>',
    ES_Footer_Mobile:
      "<script>  $( document ).ready(function() {   var yearNow = new Date().getFullYear();  $(#double;#mobile-footer-copyright-year#double;).text(yearNow );  });  </script>    <div class=#double;footer-top#double;>      <ul class=#double;footer-top-links#double;>        <li class=#double;footer-top-link-section footer-closed#double;>Customer Service</li>        <ul>          <li class=#double;hide-when-international footer__ul--hideWhenInternational#double;><a data-twist=#double;footer-return-policy#double; href=#double;/c/customerservice#double; data-cmsp=#double;customerservice-_-contactus-_-null#double;>Contact Us</a></li>          <li class=#double;hide-when-international footer__ul--hideWhenInternational#double;><a data-twist=#double;footer-faq#double; href=#double;/c/faqs-notices-policies#double; manual_cm_sp=#double;customerservice-_-faq-_-null#double;>FAQ, Notices &amp; Policies</a></li>          <li class=#double;hide-when-international footer__ul--hideWhenInternational#double;><a data-twist=#double;footer-recalls#double; href=#double;/c/faqs-notices-policies?#q=RECALL#double; manual_cm_sp=#double;customerservice-_-Recalls-_-null#double;>Product Recalls</a></li>          <li class=#double;show-when-international#double;><a data-twist=#double;footer-international-faq#double; href=#double;/c/faqs-notices-policies#double;>FAQ, Notices &amp; Policies</a></li>          <li class=#double;show-when-international#double;><a data-twist=#double;footer-recalls#double; href=#double;/c/faqs-notices-policies?#q=RECALL#double; manual_cm_sp=#double;customerservice-_-Recalls-_-null#double;>Product Recalls</a></li>    <li class=#double;show-when-international#double; data-twist=#double;footer-customer-service-international-number-1#double;><a href=#double;tel:1-817-831-5482#double;>Call 1-817-831-5482</a></li>          <li class=#double;show-when-international#double; data-twist=#double;footer-customer-service-international-hours-1#double;>Monday-Saturday: 7AM-10PM GMT-6</li>          <li class=#double;show-when-international#double; data-twist=#double;footer-customer-service-international-hours-2#double;>Sunday: 12PM-6PM GMT-6</li>          <li class=#double;show-when-international#double; data-twist=#double;footer-international-contact-us#double;><a href=#double;/internationalhelp#double; manual_cm_sp=#double;customerservice-_-ContactUS-_-null#double;>Contact Us Via Email</a></li>        </ul>        <li class=#double;hide-when-international footer-top-link-section footer-closed#double;>Dillard's Credit Card</li>        <ul>          <li class=#double;hide-when-international#double;><a href=#double;https://citiretailservices.citibankonline.com/apply/dillards-credit-card?app=UNSOL&siteId=PLCN_DILLARDS&sc=08601&cmp=A~H~F~Z~8~E~ZFZ1~AP~DL~LC#double; manual_cm_sp=#double;Footer -_-promoLink-_-111918+dillards+wells+fargo+card+online+application+footer#double; target=#double;_blank#double; rel=#double;noopener nofollow#double;>Apply for a Dillard's Card</a></li>          <li class=#double;hide-when-international#double;><a class=#double;exit-link wf-exit-link#double; data-exitlink=#double;Footer Pay Bill Online#double; rel=#double;nofollow#double; href=#double;javascript:void(0);#double; data-toggle=#double;modal#double; data-target=#double;.citi-speedbump#double; data-modal-title=#double; #double; data-modal-body=#double;citibankSpeedbump({&quot;citiLink&quot;: &quot;https://citiretailservices.citibankonline.com/RSauth/signon?pageName=signon&siteId=PLCN_DILLARDS&langId=en_US&cmp=A~A~F~M~8~E~ZFZZ~MA~DL~LC&quot;})#double; manual_cm_sp=#double;customerservice-_-PayMyBill-_-null#double; target=#double;_blank#double;>Pay Bill / View Credit Account            <span class=#double;sr-only#double;>Opens a simulated dialog</span>            </a></li>          <li class=#double;hide-when-international#double;><a href=#double;/c/DillardsCard?cmp=A~H~F~Z~8~E~ZFZ1~CB~DL~LC#double; manual_cm_sp=#double;Footer-_-ViewCreditAccount-_-CreditServices#double; title=#double;Dillard's Cardholder Benefits#double;>Dillard's Cardholder Benefits</a></li>        </ul>        <li class=#double;hide-when-international footer-top-link-section#double;><a href=#double;/stores?#double; manual_cm_sp=#double;EspotFooterBar-_-StoreLocator-_-TextLink0212#double;>Store Locations</a></li>      </ul>    </div>    <div id=#double;footer_tippy_bottom#double; class=#double;footer__tippyBottom#double;>      <div class=#double;container-fixed container#double;>        <div class=#double;row mx-0#double;>          <div class=#double;col-sm-12 paddingFix#double;>            <section class=#double;footer-links footer__section--footerLinks#double;>              <ul>                <li><a data-twist=#double;footer-sitemap#double; href=#double;/c/sitemap#double; manual_cm_sp=#double;customerservice-_-sitemap-_-null#double;>Site Map</a></li>                    <li class=#double;hide-when-international#double;><a data-twist=#double;footer-terms-of-use#double; href=#double;/c/faqs-notices-policies#q=NOTICES#double;                      manual_cm_sp=#double;customerservice-_-terms+of+use-_-null#double;>Terms Of Use</a></li>                    <li class=#double;show-when-international#double;><a data-twist=#double;footer-terms-of-use#double; href=#double;/c/faqs-notices-policies#q=int-policies-notices-question-legal-terms-of-use#double;                       manual_cm_sp=#double;customerservice-_-terms+of+use-_-null#double;>Terms Of Use</a></li>                    <li class=#double;hide-when-international#double;><a href=#double;/privacy#double; manual_cm_sp=#double;customerservice-_-privacy+policy-_-null#double;>Dillard's Privacy Policy</a></li>                    <li class=#double;show-when-international#double;><a href=#double;/privacy#double; manual_cm_sp=#double;customerservice-_-privacy+policy-_-null#double;>Dillard's Privacy Policy</a></li>              <li class=#double;hide-when-international#double;><a data-twist=#double;footer-california#double; href=#double;/c/faqs-notices-policies?#q=policies-notices-question-california#double; manual_cm_sp=#double;customerservice-_-CATransparencyAct-_-null #double;>California Transparency in                    Supply Chains Act</a></li>                <li class=#double;show-when-international#double;><a data-twist=#double;footer-california#double; href=#double;/c/faqs-notices-policies?#q=int-policies-notices-question-california#double; manual_cm_sp=#double;customerservice-_-CATransparencyAct-_-null #double;>California Transparency in                    Supply Chains Act</a></li>                <li><a target=#double;_blank#double; rel=#double;noopener#double; class=#double;exit-link yesOL#double; data-exitlink=#double;Footer Careers#double; href=#double;https://careers.dillards.com/Careers/#double;>Careers</a></li>                <li><a target=#double;_blank#double; rel=#double;noopener#double; class=#double;exit-link yesOL#double; data-exitlink=#double;Footer Investor Relations#double; href=#double;https://investor.dillards.com/overview/default.aspx#double;>Investor Relations</a></li>                <li><a target=#double;_blank#double; rel=#double;noopener#double; class=#double;exit-link yesOL#double; data-exitlink=#double;Footer About Us#double; href=#double;/c/about-dillards-company-history#double;>About Us</a></li>                <li id=#double;flag-icon-footer#double;><a href=#double;javascript:try{zonosHello();}catch(e){}#double; manual_cm_sp=#double;Footer-_-Int-_-ChangeCountry#double;><span>Change Country</span></a></li>                <li class=#double;show-when-international#double;><button type=#double;button#double; data-toggle=#double;modal#double; data-target=#double;.apo-fpo#double; data-modal-title=#double;Shipping to an APO or FPO address?#double; data-modal-body=#double;/assets/_APO_FPO-modal.html#double; rel=#double;nofollow#double;>APO / FPO</button></li>                <li><button type=#double;button#double; data-twist=#double;mobile-feedback#double; class=#double;oo_footer#double; id=#double;feedback-footer-button#double;><span class=#double;sr-only#double;>Opens chat/feedback modal</span>Chat | Feedback</button></li>                <li><button className=#double;btn-tertiary#double; data-twist=#double;footer-cookie-settings#double; id=#double;footer_cookie_settings#double; type=#double;button#double; onClick=#double;typeof Optanon !== 'undefined' && Optanon.ToggleInfoDisplay();#double;>Cookie Settings</button></li>              </ul>            </section>            <div class=#double;footer-bottom#double;>              <p data-twist=#double;toggle-shop-brands-copy#double; class=#double;copy disclaimer#double;>Prices and sale offers may vary by store location, including Dillards.com, and are subject to change. &copy; <span id=#double;mobile-footer-copyright-year#double;></span> Dillard's</p><p class=#double;qmSessionID#double;>***</p>          </div>          </div>        </div>      </div>    </div>",
    ES_EMAIL_DISCLAIMER_FOOTER:
      '<p class=#double;email-disclaimer-footer mx-auto m-l-auto m-r-auto#double; style=#double;color: white !important;#double;>We use certain tools to capture data related to when you open our messages, click on any links or banners it contains, or make purchases.</p>',
    ES_Logo:
      "<a data-twist=#double;logo#double; href=#double;/#double; manual_cm_sp=#double;Header-_-Logo-_-ImageLink#double; id=#double;logo-spot#double; alt=#double;Shop Dillards.com#double;>    <svg role='img' aria-labelledby=#double;dillardsLogo#double; height=#double;53px#double; width=#double;136px#double; version=#double;1.1#double; xmlns=#double;http://www.w3.org/2000/svg#double; xmlns:xlink=#double;http://www.w3.org/1999/xlink#double; x=#double;0px#double; y=#double;0px#double; viewBox=#double;0 0 118.3 44.8#double; style=#double;enable-background:new 0 0 118.3 44.8;#double; xml:space=#double;preserve#double;><title id=#double;dillardsLogo#double;>Dillard's The Style of Your Life Homepage</title><g><path d=#double;M39.1,29.1h0.1c2.9-0.4,5.9-0.4,8.8,0v-0.5c-2.9-0.4-2.9-0.8-3-3.9V0.4c-0.3-0.7-0.7,0-0.7,0l-1.9,1.3l-2.7,1.2v0.4c2.4,1.4,1.5,1.8,1.7,3.5v17.9c0,3,0.5,3.5-2.3,3.9c-2.7-0.4-2.9-0.8-2.9-3.9V10.9c-0.3-0.5-0.7,0-0.7,0l-1.9,1.3L31,13.4v0.4c2.4,1.4,1.6,1.8,1.7,3.5v7.4c0,3,0.5,3.5-2.4,3.9v0.5C33.2,28.7,36.2,28.7,39.1,29.1z#double;></path><path d=#double;M109.4,12.8c0.1-1.6,1.3-2.5,3-2.5c2.3,0,2.8,1.9,3.6,3.7c0,0.1,0.1,0.2,0.2,0.2c0.4,0.3,0.9,0.3,1.3-0.1c1-1,0-3.1-0.3-3.4c-1.3-0.9-2.9-1.4-4.5-1.3c-2.3,0-6.2,2.2-6.2,5.3c0,5.3,8.5,5.7,8.5,10.3c0,0,0,0,0,0c0,1.8-1.4,3.4-3.3,3.4c-2.8,0-3.7-2-4.4-3.7c0,0,0,0,0,0c0-0.4-0.4-0.6-0.7-0.6c-1,0-0.7,2.2-0.1,3.4c0.6,1.2,3,1.8,4.8,1.7v0c4-0.2,7-2.1,7-5.7C118.4,16.3,109.1,17.3,109.4,12.8z#double;></path><path d=#double;M2.6,2c0.9,0.3,1.3,1,1.3,3.3v19.3c0,4-3.9,2.6-3.8,4.2c0,0.5,2.3,0.4,2.8,0.3c1-0.4,2.1-0.5,3.2-0.5c1.5,0,4.3,0.6,9.2,0.6c4.4,0,15-1.9,14.8-14.6C30,2.4,19.5-0.1,13,0.1c-2.2,0-4.3,0.3-6.4,0.2C4.8,0,2.9,0.1,1.1,0.4c-0.3,0.1-1,0-1,1C0,1.6,1.7,1.6,2.6,2z M8.2,4.5c0-3,1.5-3.7,4.6-3.7c9.1,0,12.6,10.1,12.4,15C25,22.5,20,28.5,14.5,28.3c-1.6-0.1-6.1-0.8-6.2-4.1V4.5z#double;></path><path d=#double;M77.4,24.2v-8.3c0,0-0.4-2.1,2.1-2.3c1.6-0.2,1.5,1.9,4.1,1.6c0.1,0,0.1,0,0.2,0C82.9,17,82.4,19,82.5,21c0,4,3.1,8.1,7.4,8.2c1.8,0,3.7-0.4,5.3-1.2c0.4-0.1,0.3,1.1,0.8,1.1c0.5,0,2.6-0.4,2.6-0.4l3.3,0.4v-0.4c-2.3-1.2-1.9-3.3-1.9-4.9V0.5c0-0.7-0.4-0.2-0.4-0.2L97,1.7l-2.4,1.2l-0.1,0.3c2,1.4,1.6,1.6,1.6,3.3v5.1c-1-0.7-2.1-1.1-3.3-1.2c-2.9-0.1-5.8,1-7.9,3c0-0.3,0-0.7-0.1-1c-0.1-1.1-1.8-1.5-3-1.5c-2.6,0-4.1,2.6-4.5,2.2l-0.2-0.4v-2.5c-0.7-0.7-0.9,0-0.9,0l-1.9,1.3l-2.1,1.1V13c1.3,1.2,1.2,1.3,1.2,3.1v8.2c0,3,0.2,3.7-2.1,4.1c-2.9-0.8-2.1-1.8-2.3-6.2v-5.7c0-3.2,0.1-6-5.2-6c-5.3,0-7.3,4.2-7.3,5.3c0.1,1.5,2.5,0.2,2.9-0.4c0.4-0.7,0.9-3.9,3.6-4c2.4-0.1,2.1,3.5,2,7.8c0,0-5,1.1-7.1,3.3c-0.6,0.6-1.1,1.4-1.4,2.2c-0.5,1.5-0.3,2.5,0.2,3.2c-2.3,1.1-2.7-0.4-2.8-3.2V0.3c-0.4-0.7-0.7,0-0.7,0l-1.9,1.3l-2.7,1.3v0.4c2.4,1.4,1.6,1.8,1.7,3.5v17.9c0,3,0.5,3.5-2.4,3.9V29c2.5-0.3,5-0.3,7.5,0c0.8-0.1,1.6-0.2,2.3-0.4c0.8,0.3,1.7,0.5,2.6,0.4c1.7-0.1,3.3-0.8,4.5-2c0.8,0.7,1.6,2,2.7,2H71c0,0,0.1,0,0.1,0h0.8v-0.1c2.7-0.2,5.4-0.2,8.1,0.1c0-0.2,0-0.4,0-0.6C76.8,28.1,77.4,25.3,77.4,24.2z M92.2,11c1.8,0,4.1,0.5,4.1,5.2l0,9.7c-1,1.9-3.2,1.7-4.7,1.5c-2.9-0.4-5.5-2.4-5.6-8C86,15.4,88.5,11,92.2,11z M65.2,25.8c-0.7,0.8-1.2,1.5-2.3,1.5c-1.8,0-3-1-2.8-2.6c0.3-2.5,4.2-5,5.2-4.3v0C65.2,20.4,65.2,25.8,65.2,25.8z#double;></path><path d=#double;M34.2,6.4c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C32,5.4,33,6.4,34.2,6.4z#double;></path><path d=#double;M105.4,7.8c0.3,1.3-0.3,1.7-1.1,2.7v0c2.5-0.6,4.2-3,4-5.6c0-0.2,0-0.4,0-0.5c-0.2-1.2-1.4-2-2.6-1.7c0,0,0,0,0,0c-1.1,0.1-1.8,1.1-1.7,2.1C104.1,6.3,105,6.1,105.4,7.8z#double;></path><path d=#double;M0,35.4h0.3l0-0.1c0.5-1.9,1.5-1.9,2-1.9h0.5v7.7H1.7v0.5h4v-0.4H4.4v-7.7h0.5c0.5,0,1.5,0,2,1.9l0,0.1h0.4V33H0V35.4z#double;></path><path d=#double;M13.5,37.8c0-1.1-0.7-1.7-1.8-1.7c-0.7,0-1.5,0.3-1.9,0.9v-4.2H7.6v0.4h0.9V41H7.6v0.5h3v-0.4H9.8l0-2.5c0-0.5,0.1-1,0.4-1.4c0.3-0.4,0.8-0.6,1.3-0.7c0.7,0,0.8,0.6,0.8,0.9v3.6h-0.9v0.4h3v-0.4h-0.9V37.8z#double;></path><path d=#double;M17.7,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c0,0.7,0.2,1.4,0.7,1.9c0.5,0.5,1.1,0.8,1.8,0.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2h-0.4l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1,0-1.5-0.7-1.5-2.2v-0.4h3.6l0-0.1c0-0.6-0.1-1.2-0.5-1.6C18.8,36.5,18.3,36.2,17.7,36.1z M16.2,38.2c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2c0,0.2,0,0.3,0,0.5L16.2,38.2z#double;></path><path d=#double;M28.3,36.6l-1.5-0.5c-0.8-0.3-1.6-0.6-1.6-1.5c0-0.8,0.7-1.5,1.6-1.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c1.1,0,2,0.9,2.1,2l0,0.1h0.4V33h-0.4l0,0.1c-0.1,0.2-0.1,0.2-0.2,0.2s-0.3-0.1-0.5-0.1c-0.3-0.1-0.7-0.3-1.4-0.3c0,0,0,0,0,0c-1.4-0.1-2.6,1-2.7,2.4c0,0.1,0,0.1,0,0.2c0,1.1,0.6,1.8,2,2.1l1.3,0.4c0.8,0.1,1.4,0.8,1.5,1.6c0,0.5-0.1,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.1,0-0.2,0-0.3,0c-0.9,0-2.2,0-2.7-2.4l0-0.1h-0.4l0,2.8h0.4l0-0.1c0-0.1,0.1-0.2,0.2-0.2c0.3,0,0.7,0.1,1,0.3c0.5,0.1,1,0.2,1.5,0.2c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.3,1.9-0.7c0.6-0.5,0.9-1.2,1-2c0-0.1,0-0.1,0-0.2C30.3,37.2,29,36.8,28.3,36.6z#double;></path><path d=#double;M35,40.4l-0.4-0.2l0,0.2c0,0.5-0.4,0.9-0.9,0.9c-0.1,0-0.6,0-0.6-0.9v-3.7h1.7v-0.4h-1.7v-1.8L33,34.7c-0.1,0.1-0.3,0.2-0.5,0.1c-0.1,0-0.3,0-0.4-0.1l-0.2-0.1v1.6H31v0.4h0.9v3.6c0,1,0.5,1.4,1.7,1.4c0,0,0.1,0,0.1,0C34.4,41.7,34.9,41.2,35,40.4L35,40.4z#double;></path><path d=#double;M41.1,36.3h-2v0.4H40l-1.4,3.2l-1.3-3.2h0.9v-0.4h-3.2v0.4H36l2,4.9l-0.5,1.3c-0.5,1.3-0.8,1.6-1.2,1.6c-0.2,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.3-0.4-0.5-0.7-0.5c-0.4,0-0.6,0.3-0.7,0.6c0,0,0,0.1,0,0.1c0,0.6,0.5,1,1,1c0,0,0.1,0,0.1,0c0.8,0,1.2-0.6,1.7-1.7c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-0.9,0.6-1.4l1.9-4.4h0.7V36.3z#double;></path><polygon points=#double;43.2,32.9 41.1,32.9 41.1,33.3 42,33.3 42,41.1 41.1,41.1 41.1,41.5 44.1,41.5 44.1,41.1 43.2,41.1 #double;></polygon><path d=#double;M47.4,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c0,0.7,0.2,1.4,0.7,1.9c0.5,0.5,1.1,0.8,1.8,0.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2H49l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1.2,0-1.4-1.2-1.4-2.2v-0.4l3.6,0l0-0.1c0-0.6-0.1-1.2-0.5-1.6C48.6,36.5,48,36.2,47.4,36.1z M45.9,38.2c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2c0,0.2,0,0.3,0,0.5L45.9,38.2z#double;></path><path d=#double;M56.9,36.7C56.9,36.7,56.9,36.7,56.9,36.7c-0.2-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-1.4,0.1-2.6,1.2-2.7,2.7v0c0,0.8,0.4,1.4,1,2c0.5,0.5,1.2,0.7,1.9,0.7c0.1,0,0.1,0,0.2,0c1.4-0.1,2.6-1.2,2.7-2.7c0-0.8-0.4-1.4-1-2C57.1,36.9,57,36.8,56.9,36.7z M55.3,36.6c0.8,0,1.4,0.4,1.4,2.4c0,2.2-0.7,2.4-1.4,2.4s-1.4-0.2-1.4-2.4C53.9,37,54.5,36.6,55.3,36.6z#double;></path><path d=#double;M63.3,33.8C63.3,33.7,63.3,33.7,63.3,33.8c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0-0.1c-0.2-0.4-0.7-0.7-1.4-0.7h0c-0.7,0.1-1.4,0.4-1.8,1.1c-0.4,0.6-0.6,1.3-0.5,2v0.5h-0.9v0.4h0.9v4.4h-0.9v0.4h3.2v-0.4h-1.1v-4.4h1.4v-0.4h-1.4v-1.5c0-1,0.4-1.6,1-1.6c0.2,0,0.5,0.1,0.5,0.3c0,0.2-0.1,0.2-0.1,0.3C62.1,34,62,34.1,62,34.2c0,0.3,0.4,0.5,0.6,0.5c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1C63.4,33.9,63.4,33.9,63.3,33.8z#double;></path><polygon points=#double;73.6,33.4 74.8,33.4 74.8,33 72.1,33 72.1,33.4 73.2,33.4 71.2,37.1 69.1,33.4 70.1,33.4 70.1,33 66.3,33 66.3,33.4 67.4,33.4 70,37.9 70,41.1 68.7,41.1 68.7,41.5 72.7,41.5 72.7,41.1 71.4,41.1 71.4,37.6 #double;></polygon><path d=#double;M85.7,41.1v-4.8h-2.1v0.4h0.9v2.6c0.1,1-0.6,1.8-1.5,2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.6-0.2-1v-3.6h-0.1v-0.1H80v0.4h0.9v3.2c0,1,0.4,1.3,0.6,1.5c0.3,0.2,0.7,0.3,1.2,0.3c0,0,0.1,0,0.1,0c0.7,0,1.3-0.4,1.7-0.9v0.7h2.1l0-0.1h0l0,0l0-0.3H85.7z#double;></path><path d=#double;M90.8,36.1C90.8,36.1,90.8,36.1,90.8,36.1c-0.6,0-1.1,0.3-1.4,0.8v-0.6h-2.2v0.4h0.9v4.4h-0.9v0.4h3.1v-0.4h-1v-2.5c0-1.3,0.7-1.9,1.1-1.9c0.3,0,0.3,0.1,0.3,0.2c0,0.2,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3c0,0.4,0.4,0.4,0.6,0.4c0.5,0,0.7-0.3,0.7-0.8C91.9,36.6,91.4,36.1,90.8,36.1z#double;></path><path d=#double;M102.1,38.8c-0.4,1.5-1.1,2.3-2.3,2.3h-1.9v-7.7h1.3v-0.1h0v-0.2h0V33h-4v0.4h1.3v7.7h-1.3v0.4h7.3v-2.8L102.1,38.8L102.1,38.8z#double;></path><polygon points=#double;105.5,36.3 103.4,36.3 103.4,36.7 104.2,36.7 104.2,41.1 103.4,41.1 103.3,41.5 106.4,41.5 106.4,41.1 105.5,41.1 #double;></polygon><circle cx=#double;104.8#double; cy=#double;33.7#double; r=#double;0.7#double;></circle><path d=#double;M109.1,34.8c0-1,0.4-1.6,1-1.6c0.3,0,0.5,0.1,0.5,0.3c0,0.2-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.3,0.4,0.5,0.6,0.5c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1c0-0.5-0.5-1.2-1.6-1.2h0c-0.7,0.1-1.4,0.4-1.8,1.1c-0.4,0.6-0.6,1.3-0.5,2v0.5H107v0.4h0.9v4.4H107l-0.1,0.4h3.2v-0.2h0v-0.2h0v0h-1v-4.4h1.4v-0.4h-1.4V34.8z#double;></path><path d=#double;M113.6,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c-0.1,1.5,1.1,2.7,2.6,2.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2h-0.4l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1.2,0-1.4-1.2-1.4-2.2v-0.4l3.6,0l0-0.1c0-0.6-0.1-1.2-0.5-1.6C114.8,36.5,114.2,36.2,113.6,36.1z M114.3,38.2l-2.1,0c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2C114.3,37.9,114.3,38.1,114.3,38.2z#double;></path><circle cx=#double;117.6#double; cy=#double;40.9#double; r=#double;0.7#double;></circle><path d=#double;M77,36.2L77,36.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-1.4,0.1-2.6,1.2-2.7,2.7v0c0,0.8,0.4,1.4,1,2c0.5,0.5,1.2,0.7,1.9,0.7c0.1,0,0.1,0,0.2,0c0.8,0,1.5-0.4,2-1c0.4-0.4,0.6-1,0.7-1.6C79.6,37.4,78.5,36.3,77,36.2z M75.5,38.9c0-1.1,0.2-1.7,0.5-2.1c0.2-0.2,0.5-0.2,0.8-0.2c0.8,0,1.4,0.4,1.4,2.4c0,2.2-0.7,2.4-1.4,2.4c-0.4,0-0.9-0.1-1.1-0.6C75.5,40.2,75.5,39.7,75.5,38.9z#double;></path></g></svg></a>",
    ES_Tippy_Top_HTML: '&nbsp;',
    ES_Header_Promo_JSON: [
      "<div class='promoHeading'><a href='/c/ios-update-for-dillards-email' manual_cm_sp='header-_-promoLink-_-121824+ios+email+update+shop+now' tabindex='-1'><p>iPhone Update & Can’t Find Our Emails in Your Inbox? <span class='promoTextLink'>CLICK HERE</span> to help.</p></a></div>",
      "<div class='promoHeading'><a href='/search-term/style+by+simkins' manual_cm_sp='header-_-promoLink-_-022125+antonio+melani+simkins+shop+now' tabindex='-1'><p>Antonio Melani x Style By Simkins - <span class='promoTextLink'>SHOP NOW</span></p></a></div>",
      "<div class='promoHeading'><a href='/c/DillardsCard?cmp=A~H~H~J~8~E~ZZZ1~LM~DL~LC' manual_cm_sp='header-_-promoLink-_-081924+citi+dillards+card+shop+now' tabindex='-1'><p>EARN POINTS WHEN YOU USE YOUR DILLARD’S CREDIT CARD - <span class='promoTextLink'>LEARN MORE</span></p></a></div></p></a>",
    ],
    ES_Consolidated_Header:
      '<ul>   <li>      <a href=#double;/c/sale-clearance#double; manual_cm_sp=#double;Header-_-SaleClearance-_-TextLink#double; class=#double;sale-clearance text--clearance#double;>Sale and Clearance</a>   </li>   <li>      <a href=#double;/c/shopbybrand#double; manual_cm_sp=#double;Header-_-ShopByBrand-_-TextLink#double;>Shop By Brand</a>   </li>   <li>      <a style=#double;color:#267cb5;#double; href=#double;/c/limited-availability#double; manual_cm_sp=#double;Header-_-LimitedAvailability-_-TextLink#double; class=#double;text--limitedAvailability#double;>Limited Availability</a>   </li></ul>',
    ES_Footer_1:
      '<div id=#double;customer-service#double;>    <section><style>       .footer__h2{   font-family: Open Sans,sans-serif;   font-weight: 600;   text-transform: uppercase;   letter-spacing: 1px;   margin-bottom: 5px;   font-size: .875rem;   color: #fff;   display: block;}   </style>        <h2 class=#double;footer__h2#double;>Customer Service</h2>    </section>    <section class=#double;footer-links footer__section--footerLinks#double;>        <ul class=#double;hide-when-international footer__ul--hideWhenInternational#double;>            <li><a data-twist=#double;footer-returns-exchanges#double; data-ref=#double;footerReturnsExchanges#double;                href=#double;/c/customerservice#double; manual_cm_sp=#double;customerservice-_-orderstatus-_-null#double; rel=#double;nofollow#double;>Contact Us</a>            </li>            <li><a data-twist=#double;footer-faq#double; href=#double;/c/faqs-notices-policies#double;                    manual_cm_sp=#double;customerservice-_-faq-_-null#double;>FAQ, Notices &amp; Policies</a></li>            <li><a data-twist=#double;footer-recalls#double; href=#double;/c/faqs-notices-policies?#q=RECALL#double;                    manual_cm_sp=#double;customerservice-_-Recalls-_-null#double;>Product Recalls</a></li>            <li><a href=#double;/c/returns#double; manual_cm_sp=#double;customerservice-_-returns-_-footer#double;>Returns</a></li>            <li><button type=#double;button#double; data-twist=#double;feedback#double; class=#double;oo_footer#double;                    id=#double;feedback-footer-button#double;>Chat | Feedback                    <span class=#double;sr-only#double;>Opens chat/feedback modal</span></button></li>        </ul>        <ul class=#double;show-when-international#double;>            <li><a data-twist=#double;footer-international-faq#double; href=#double;/c/faqs-notices-policies#double;>FAQ, Notices                    &amp; Policies</a></li>            <li class=#double;show-when-international#double;><a data-twist=#double;footer-recalls#double; href=#double;/c/faqs-notices-policies#double;                    manual_cm_sp=#double;customerservice-_-Recalls-_-null#double;>Product Recalls</a></li>            <li><button type=#double;button#double; data-twist=#double;feedback-international#double; class=#double;oo_footer#double;                    id=#double;feedback-footer-button-international#double;>Chat | Feedback                    <span class=#double;sr-only#double;>Opens chat/feedback modal</span></button></li>        </ul>    </section></div>',
    ES_Footer_2:
      "<div id=#double;credit-card-and-company#double;>    <div class=#double;#double;>        <section>  <style>       .footer__h2{     font-family: Open Sans,sans-serif;   font-weight: 600;   text-transform: uppercase;   letter-spacing: 1px;   margin-bottom: 5px;   font-size: .875rem;   color: #fff;     }         </style>            <h2 class=#double;footer__h2 hide-when-international#double;>Dillard's Credit Card</h2>        </section>        <section class=#double;footer-links footer__section--footerLinks hide-when-international#double;>            <ul>                <li><a class=#double;exit-link wf-exit-link#double; data-exitlink=#double;Footer Apply for a Dillard's Card#double; rel=#double;noopener nofollow#double;                        href=#double;https://citiretailservices.citibankonline.com/apply/dillards-credit-card?app=UNSOL&siteId=PLCN_DILLARDS&sc=08601&cmp=A~H~F~Z~8~E~ZFZ1~AP~DL~LC#double;                         manual_cm_sp=#double;customerservice-_-ApplyDillardsCard-_-null#double; target=#double;_blank#double;                        >Apply for a Dillard's Card                        <span class=#double;sr-only#double;>Apply for a Dillard's Card</span>                    </a></li>                <li><a class=#double;exit-link wf-exit-link#double; data-exitlink=#double;Footer Pay Bill Online#double; rel=#double;noopener nofollow#double;                        href=#double;javascript:void(0);#double; data-toggle=#double;modal#double; data-target=#double;.citi-speedbump#double;                        data-modal-title=#double; #double;                        data-modal-body=#double;citibankSpeedbump({&quot;citiLink&quot;: &quot;https://citiretailservices.citibankonline.com/RSauth/signon?pageName=signon&siteId=PLCN_DILLARDS&langId=en_US&cmp=A~A~F~M~8~E~ZFZZ~MA~DL~LC&quot;})#double;                        manual_cm_sp=#double;customerservice-_-PayMyBill-_-null#double; target=#double;_blank#double;                        >Pay Bill / View Credit Account                        <span class=#double;sr-only#double;>Opens a simulated dialog</span>                    </a></li>                    <li><a class=#double;exit-link wf-exit-link#double; data-exitlink=#double;Footer Dillard's Cardholder Benefits#double; rel=#double;noopener nofollow#double;                            href=#double;/c/DillardsCard?cmp=A~A~F~Z~8~E~ZFZZ~CB~DL~LC#double;                             manual_cm_sp=#double;customerservice-_-DillardsCardholderBenefits-_-null#double;                            >Dillard's Cardholder Benefits                            <span class=#double;sr-only#double;>Dillard's Cardholder Benefits</span>                        </a></li>            </ul>        </section>            <section class=#double;footer-links footer__section--footerLinks show-when-international#double;>           <h2 class=#double;footer__h2 show-when-international #double;>Contact Us</h2> <ul>                <li data-twist=#double;footer-customer-service-international-number-1#double;>Call 1-817-831-5482</li>            <li data-twist=#double;footer-customer-service-international-hours-1#double;>Monday-Friday: 7AM-9PM                GMT-6</li>            <li data-twist=#double;footer-customer-service-international-hours-2#double;>Saturday-Sunday: 9AM-7PM GMT-6            </li>            <li data-twist=#double;footer-international-contact-us#double;><a href=#double;/internationalhelp#double;                    manual_cm_sp=#double;customerservice-_-ContactUS-_-null#double;>Contact Us Via Email</a></li>            </ul>        </section>    </div>  </div>",
    ES_Footer_3:
      '<div id=#double;more-way-to-shop#double;>    <div data-espotname=#double;ES_Footer_3#double; class=#double;#double;>        <section><style>       .footer__h2{   font-family: Open Sans,sans-serif;   font-weight: 600;   text-transform: uppercase;   letter-spacing: 1px;   margin-bottom: 5px;   font-size: .875rem;   color: #fff;   display: block;}   </style>            <h2 data-twist=#double;footer-more-ways-to-shop-header#double; class=#double;footer__h2#double;>More Ways To Shop</h2>        </section>        <section class=#double;footer-links footer__section--footerLinks#double;>            <ul>                <li class=#double;hide-when-international#double;><a data-twist=#double;footer-registry#double; href=#double;/registry#double;                        manual_cm_sp=#double;EspotFooterBar--Registry--TextLink0212#double;>Registry - Wedding,                        Baby, and Gift</a></li>                <li class=#double;hide-when-international#double;><a data-twist=#double;footer-gift-card#double; href=#double;/c/giftcard#double;                        manual_cm_sp=#double;EspotFooterBar--GiftCards--TextLink0212#double;> Gift Cards</a></li>                <li class=#double;hide-when-international#double;><a data-twist=#double;footer-store-locator#double; href=#double;/stores#double;                        manual_cm_sp=#double;EspotFooterBar--StoreLocator--TextLink0212#double;>Store Locations</a>                </li>                <li id=#double;flag-icon-footer#double;><a href=#double;javascript:try{zonosHello();}catch(e){}#double; manual_cm_sp=#double;Footer--Int--ChangeCountry#double;><span>Change Country</span></a></li>                <li class=#double;show-when-international#double;><button type=#double;button#double; data-toggle=#double;modal#double; data-target=#double;.apo-fpo#double;                        data-modal-title=#double;Shipping to an APO or FPO address?#double;                        data-modal-body=#double;/assets/_APO_FPO-modal.html#double; rel=#double;nofollow#double;>APO / FPO</button></li>            </ul>        </section>    </div></div>',
    ES_Footer_4: '&nbsp;',
    OptimizelyDataFile: {
      accountId: '29040210089',
      projectId: '29040210089',
      revision: '139',
      attributes: [
        { id: '29438610056', key: 'membershipLevel' },
        { id: '29453230145', key: 'isLoggedIn' },
        { id: '29922290294', key: 'currentURL' },
        { id: '29943670181', key: 'isMobile' },
        { id: '29963190060', key: 'isDillardsUser' },
        { id: '5127648863584256', key: 'Googlebot' },
        { id: '5761627006435328', key: 'isDillardsUser-isGooglebot' },
        { id: '6737786552713216', key: 'isGooglebot' },
      ],
      audiences: [
        {
          name: 'isDillardsUser',
          conditions:
            '["or", {"match": "exact", "name": "$opt_dummy_attribute", "type": "custom_attribute", "value": "$opt_dummy_value"}]',
          id: '29939810197',
        },
        {
          name: 'isNotDillardsUser',
          conditions:
            '["or", {"match": "exact", "name": "$opt_dummy_attribute", "type": "custom_attribute", "value": "$opt_dummy_value"}]',
          id: '29939950395',
        },
        {
          name: 'isMobileDevice',
          conditions:
            '["or", {"match": "exact", "name": "$opt_dummy_attribute", "type": "custom_attribute", "value": "$opt_dummy_value"}]',
          id: '29958520036',
        },
        {
          id: '$opt_dummy_audience',
          name: 'Optimizely-Generated Audience for Backwards Compatibility',
          conditions:
            '["or", {"match": "exact", "name": "$opt_dummy_attribute", "type": "custom_attribute", "value": "$opt_dummy_value"}]',
        },
      ],
      version: '4',
      events: [
        { id: '29851020480', experimentIds: [], key: 'facetBreadcrumbs' },
        { id: '29890420081', experimentIds: ['9300001422105'], key: 'showHorizCategoryNavigation' },
        {
          id: '29953760907',
          experimentIds: [
            '9300001422103',
            '9300001422102',
            '9300001422105',
            '9300001422106',
            '9300002085892',
            '9300001422104',
          ],
          key: 'orderComplete',
        },
        { id: '5548749393494016', experimentIds: ['9300002085892'], key: 'salepdpvsnonsalerecs' },
      ],
      integrations: [],
      anonymizeIP: true,
      botFiltering: false,
      typedAudiences: [
        {
          name: 'isDillardsUser',
          conditions: [
            'and',
            ['or', ['or', { match: 'exact', name: 'isDillardsUser', type: 'custom_attribute', value: true }]],
          ],
          id: '29939810197',
        },
        {
          name: 'isNotDillardsUser',
          conditions: [
            'and',
            ['or', ['or', { match: 'exact', name: 'isDillardsUser', type: 'custom_attribute', value: false }]],
          ],
          id: '29939950395',
        },
        {
          name: 'isMobileDevice',
          conditions: [
            'and',
            ['or', ['or', { match: 'exact', name: 'isMobile', type: 'custom_attribute', value: true }]],
          ],
          id: '29958520036',
        },
      ],
      variables: [],
      environmentKey: 'production',
      sdkKey: 'LBGfwqspT8NVr91gGPLQR',
      featureFlags: [
        {
          id: '213691',
          key: 'generalfeedbackinvite',
          rolloutId: 'rollout-213691-28983430728',
          experimentIds: ['9300001422102'],
          variables: [],
        },
        {
          id: '214394',
          key: 'postpurchasesurvey',
          rolloutId: 'rollout-214394-28983430728',
          experimentIds: ['9300001422103'],
          variables: [],
        },
        {
          id: '233851',
          key: 'ismobiledonothing',
          rolloutId: 'rollout-233851-28983430728',
          experimentIds: ['9300001422104'],
          variables: [],
        },
        {
          id: '235357',
          key: 'showhorizcategorynavigation',
          rolloutId: 'rollout-235357-28983430728',
          experimentIds: ['9300001422105'],
          variables: [],
        },
        {
          id: '235368',
          key: 'slimfactorfix',
          rolloutId: 'rollout-235368-28983430728',
          experimentIds: ['9300001422106'],
          variables: [],
        },
        {
          id: '236422',
          key: 'movecardandafterpaymobile',
          rolloutId: 'rollout-236422-28983430728',
          experimentIds: [],
          variables: [],
        },
        {
          id: '355812',
          key: 'salepdpvsnonsalerecs',
          rolloutId: 'rollout-355812-28983430728',
          experimentIds: ['9300002085892'],
          variables: [],
        },
      ],
      rollouts: [
        {
          id: 'rollout-213691-28983430728',
          experiments: [
            {
              id: '9300001489298',
              key: 'generalfeedbackinvite_-_dillard_users',
              status: 'Running',
              layerId: '9300001009838',
              variations: [{ id: '697385', key: 'expb', featureEnabled: true, variables: [] }],
              trafficAllocation: [{ entityId: '697385', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: ['29939810197'],
              audienceConditions: ['or', '29939810197'],
            },
            {
              id: 'default-rollout-213691-28983430728',
              key: 'default-rollout-213691-28983430728',
              status: 'Running',
              layerId: 'rollout-213691-28983430728',
              variations: [{ id: '697377', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '697377', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-214394-28983430728',
          experiments: [
            {
              id: '9300001489288',
              key: 'postpurchasesurvey_-_dillard_users',
              status: 'Running',
              layerId: '9300001009828',
              variations: [{ id: '787940', key: 'expb', featureEnabled: true, variables: [] }],
              trafficAllocation: [{ entityId: '787940', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: ['29939810197'],
              audienceConditions: ['or', '29939810197'],
            },
            {
              id: 'default-rollout-214394-28983430728',
              key: 'default-rollout-214394-28983430728',
              status: 'Running',
              layerId: 'rollout-214394-28983430728',
              variations: [{ id: '700804', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '700804', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-233851-28983430728',
          experiments: [
            {
              id: 'default-rollout-233851-28983430728',
              key: 'default-rollout-233851-28983430728',
              status: 'Running',
              layerId: 'rollout-233851-28983430728',
              variations: [{ id: '785674', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '785674', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-235357-28983430728',
          experiments: [
            {
              id: '9300001489280',
              key: 'showhorizcategorynavigation_-_dillard_users',
              status: 'Running',
              layerId: '9300001009820',
              variations: [{ id: '787619', key: 'expb', featureEnabled: true, variables: [] }],
              trafficAllocation: [{ entityId: '787619', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: ['29939810197'],
              audienceConditions: ['or', '29939810197'],
            },
            {
              id: 'default-rollout-235357-28983430728',
              key: 'default-rollout-235357-28983430728',
              status: 'Running',
              layerId: 'rollout-235357-28983430728',
              variations: [{ id: '787607', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '787607', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-235368-28983430728',
          experiments: [
            {
              id: '9300001489278',
              key: 'slimfactorfix_-_dillard_users',
              status: 'Running',
              layerId: '9300001009818',
              variations: [{ id: '787639', key: 'expb', featureEnabled: true, variables: [] }],
              trafficAllocation: [{ entityId: '787639', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: ['29939810197'],
              audienceConditions: ['or', '29939810197'],
            },
            {
              id: 'default-rollout-235368-28983430728',
              key: 'default-rollout-235368-28983430728',
              status: 'Running',
              layerId: 'rollout-235368-28983430728',
              variations: [{ id: '787634', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '787634', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-236422-28983430728',
          experiments: [
            {
              id: 'default-rollout-236422-28983430728',
              key: 'default-rollout-236422-28983430728',
              status: 'Running',
              layerId: 'rollout-236422-28983430728',
              variations: [{ id: '790930', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '790930', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
        {
          id: 'rollout-355812-28983430728',
          experiments: [
            {
              id: '9300002085893',
              key: 'salepdpvsnonsalerecs_-_dillard_users',
              status: 'Running',
              layerId: '9300001469031',
              variations: [{ id: '1117585', key: 'expb', featureEnabled: true, variables: [] }],
              trafficAllocation: [{ entityId: '1117585', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: ['29939810197'],
              audienceConditions: ['or', '29939810197'],
            },
            {
              id: 'default-rollout-355812-28983430728',
              key: 'default-rollout-355812-28983430728',
              status: 'Running',
              layerId: 'rollout-355812-28983430728',
              variations: [{ id: '1115070', key: 'off', featureEnabled: false, variables: [] }],
              trafficAllocation: [{ entityId: '1115070', endOfRange: 10000 }],
              forcedVariations: {},
              audienceIds: [],
              audienceConditions: [],
            },
          ],
        },
      ],
      experiments: [
        {
          id: '9300001422102',
          key: 'isnotdillardsuser',
          status: 'Running',
          layerId: '9300000970782',
          variations: [
            { id: '697383', key: 'expa', featureEnabled: true, variables: [] },
            { id: '697385', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '697383', endOfRange: 8500 },
            { entityId: '697385', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29939950395'],
          audienceConditions: ['or', '29939950395'],
        },
        {
          id: '9300001422103',
          key: 'isnotdillardsuser2',
          status: 'Running',
          layerId: '9300000970783',
          variations: [
            { id: '787939', key: 'expa', featureEnabled: true, variables: [] },
            { id: '787940', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '787939', endOfRange: 7500 },
            { entityId: '787940', endOfRange: 8500 },
            { entityId: '787940', endOfRange: 9000 },
            { entityId: '787939', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29939950395'],
          audienceConditions: ['or', '29939950395'],
        },
        {
          id: '9300001422104',
          key: 'ismobiledevice',
          status: 'Running',
          layerId: '9300000970784',
          variations: [
            { id: '785676', key: 'expa', featureEnabled: true, variables: [] },
            { id: '785677', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '785676', endOfRange: 5000 },
            { entityId: '785677', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29958520036'],
          audienceConditions: ['or', '29958520036'],
        },
        {
          id: '9300001422105',
          key: 'isnotdillardsuser1',
          status: 'Running',
          layerId: '9300000970785',
          variations: [
            { id: '787618', key: 'expa', featureEnabled: true, variables: [] },
            { id: '787619', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '787619', endOfRange: 5000 },
            { entityId: '787619', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29939950395'],
          audienceConditions: ['or', '29939950395'],
        },
        {
          id: '9300001422106',
          key: 'isnotdillardsuser3',
          status: 'Running',
          layerId: '9300000970786',
          variations: [
            { id: '787637', key: 'expa', featureEnabled: true, variables: [] },
            { id: '787639', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '787639', endOfRange: 5000 },
            { entityId: '787639', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29939950395'],
          audienceConditions: ['or', '29939950395'],
        },
        {
          id: '9300002085892',
          key: 'isnotdillardsuser-salesRecs',
          status: 'Running',
          layerId: '9300001469030',
          variations: [
            { id: '1117582', key: 'expa', featureEnabled: true, variables: [] },
            { id: '1117585', key: 'expb', featureEnabled: true, variables: [] },
          ],
          trafficAllocation: [
            { entityId: '1117582', endOfRange: 5000 },
            { entityId: '1117585', endOfRange: 10000 },
          ],
          forcedVariations: {},
          audienceIds: ['29939950395'],
          audienceConditions: ['or', '29939950395'],
        },
      ],
      groups: [],
    },
    StatesList: [
      { AL: 'Alabama' },
      { AK: 'Alaska' },
      { AS: 'American Samoa' },
      { AZ: 'Arizona' },
      { AR: 'Arkansas' },
      { AA: 'Armed Forces Americas' },
      { AE: 'Armed Forces Europe' },
      { AP: 'Armed Forces Pacific' },
      { CA: 'California' },
      { CO: 'Colorado' },
      { CT: 'Connecticut' },
      { DE: 'Delaware' },
      { DC: 'District of Columbia' },
      { FM: 'Federated States of Micronesia' },
      { FL: 'Florida' },
      { GA: 'Georgia' },
      { GU: 'Guam' },
      { HI: 'Hawaii' },
      { ID: 'Idaho' },
      { IL: 'Illinois' },
      { IN: 'Indiana' },
      { IA: 'Iowa' },
      { KS: 'Kansas' },
      { KY: 'Kentucky' },
      { LA: 'Louisiana' },
      { ME: 'Maine' },
      { MH: 'Marshall Islands' },
      { MD: 'Maryland' },
      { MA: 'Massachusetts' },
      { MI: 'Michigan' },
      { MN: 'Minnesota' },
      { MS: 'Mississippi' },
      { MO: 'Missouri' },
      { MT: 'Montana' },
      { NE: 'Nebraska' },
      { NV: 'Nevada' },
      { NH: 'New Hampshire' },
      { NJ: 'New Jersey' },
      { NM: 'New Mexico' },
      { NY: 'New York' },
      { NC: 'North Carolina' },
      { ND: 'North Dakota' },
      { MP: 'Northern Mariana Islands' },
      { OH: 'Ohio' },
      { OK: 'Oklahoma' },
      { OR: 'Oregon' },
      { PW: 'Palau' },
      { PA: 'Pennsylvania' },
      { PR: 'Puerto Rico' },
      { RI: 'Rhode Island' },
      { SC: 'South Carolina' },
      { SD: 'South Dakota' },
      { TN: 'Tennessee' },
      { TX: 'Texas' },
      { UM: 'U.S. Minor Outlying Islands' },
      { VI: 'U.S. Virgin Islands' },
      { UT: 'Utah' },
      { VT: 'Vermont' },
      { VA: 'Virginia' },
      { WA: 'Washington' },
      { WV: 'West Virginia' },
      { WI: 'Wisconsin' },
      { WY: 'Wyoming' },
    ],
  },
};

export {
  pathConfig,
  nodePaths,
  nodeDataPaths,
  oneDataCall,
  fallbackHeaderFooterJSON,
  facetCovering,
  cookiePassNodePaths,
  cookiePassNodeDataPaths,
};
